import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-nomeacao-versus-parametrizacao',
    templateUrl: 'nomeacao-versus-parametrizacao.html',
    providers: [
        PessoalService
    ]
})
export class PessoalNomeacaoVersusParametrizacaoPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "106";

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(11);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    carregarDados() {
        this.pessoalService.obterNomeacaoVersusParametrizacao().subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaPessoal() {
        this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
    }

    salvarFlagIncluir() {
        this.pessoalService.salvarNomeacaoVersusParametrizacao(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
        })
    }

    submeterNoCertificado() {
        let idAnalise = "";

        if (this.listaDados) {
            idAnalise = this.listaDados.idModuloAnalise;

            this.pessoalService.finalizarNomeacaoVersusParametrizacao(this.listaDados).subscribe(data => {
                this.alertService.mostraAlerta("", "Submetido com sucesso.");
                this.voltarParaPessoal();
            }, error => {
                this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/nomeacao-versus-parametrizacao/nomeacao-versus-parametrizacao.ts